import { AutoMap } from "@automapper/classes";
import { Entity } from "../base/entity.model";

export class ActivityType extends Entity {

    @AutoMap()
  public description!: string;

}